import React, { createContext, useState, useEffect } from 'react';
import { supabase } from '../Supabase/Config';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [_auth, _setAuth] = useState(false); 
  const [userInfo, setUserInfo] = useState({
    'name': null,
    'tokens': null,
    'picture': null,
    'email': null
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        if (session) {
          _setAuth(true);
          const user = session.user;
          setUserInfo({
            'tokens': sessionStorage.getItem('tokens') || '100',
            'name': user.user_metadata?.full_name || user.email?.split('@')[0] || 'User',
            'picture': user.user_metadata?.avatar_url || null,
            'email': user.email
          });
          localStorage.setItem('jwt', session.access_token);
        } else {
          _setAuth(false);
          setUserInfo({
            'name': null,
            'tokens': null,
            'picture': null,
            'email': null
          });
        }
      } catch (error) {
        console.error('Error checking session:', error);
        _setAuth(false);
      } finally {
        setLoading(false);
      }
    };

    checkSession();

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        console.log('Auth state changed:', event);
        
        if (session) {
          _setAuth(true);
          const user = session.user;
          setUserInfo({
            'tokens': sessionStorage.getItem('tokens') || '100',
            'name': user.user_metadata?.full_name || user.email?.split('@')[0] || 'User',
            'picture': user.user_metadata?.avatar_url || null,
            'email': user.email
          });
          localStorage.setItem('jwt', session.access_token);
          sessionStorage.setItem('name', user.user_metadata?.full_name || user.email?.split('@')[0] || 'User');
        } else {
          _setAuth(false);
          setUserInfo({
            'name': null,
            'tokens': null,
            'picture': null,
            'email': null
          });
          localStorage.removeItem('jwt');
        }
      }
    );

    return () => {
      subscription?.unsubscribe();
    };
  }, []);

  return (
    <AuthContext.Provider value={{ _auth, _setAuth, userInfo, setUserInfo, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
